import {
  GET_ACCOUNT_ALERTS_PREFERENCES_FAILED,
  GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED,
  GET_ACCOUNT_ALERTS_PREFERENCES_PENDING,
} from "../actions/actionTypes";
import { LoadingState } from "../helpers/enum";

const initialState = {};

export default function accountAlertPreferencesReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_ACCOUNT_ALERTS_PREFERENCES_PENDING:
      return {
        ...state,
        [action.accountno]: { loadingState: LoadingState.PENDING }
      };
    case GET_ACCOUNT_ALERTS_PREFERENCES_FAILED:
      return {
        ...state,
        [action.accountno]: { loadingState: LoadingState.FAILED }
      };
    case GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED:
      return {
        ...state,
        [action.accountno]: {
          loadingState: LoadingState.FULFILLED,
          items: action.data
        }
      };
    default:
      return state;
  }
}
